import React from 'react'

import { IconBase } from '../IconBase'
import { IconProps } from '../types'

export const Check: React.FC<IconProps> = (props) => (
  <IconBase {...props}>
    <path
      d="M20 6L9 17L4 12"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </IconBase>
)
